export enum RepositoryKey {
    USERNAME = 'username',
    PERMISSIONS = 'permissions',
    FIRST_LOGIN = 'first_login',
    AFFILIATE_STATUS = 'affiliate_status',
    TOKEN = 'token',
    DARK_THEME = 'dark_theme',
    APPLICATION_SHOW_BANNED_APPS = 'application_show_banned_app',
    WEBSITE_SHOW_BANNED_WEBSITES = 'website_show_banned_websites',
    CLICK_SHOW_WITHOUT_APP = 'click_show_without_app',
    WEB_CLICK_SHOW_WITHOUT_WEBSITE = 'web_click_show_without_website',
    PWA_CLICK_SHOW_WITHOUT_PWA = 'pwa_click_show_without_pwa',
    LINKULA_CLICK_SHOW_WITHOUT_LINKULA = 'linkula_click_show_without_linkula',
    EVENT_SHOW_WITHOUT_APP = 'event_show_without_app',
    WEB_EVENT_SHOW_WITHOUT_WEBSITE = 'web_event_show_without_website',
    PWA_EVENT_SHOW_WITHOUT_PWA = 'pwa_event_show_without_pwa',
    PUSH_EVENT_SHOW_WITHOUT_PUSH = 'push_event_show_without_push',
    PWA_PUSH_EVENT_SHOW_WITHOUT_PUSH = 'pwa_push_event_show_without_push',
    LINKULA_EVENT_SHOW_WITHOUT_LINKULA = 'linkula_event_show_without_linkula',
    OFFER_SELECTED_GEO = 'offer_selected_geo',
    SPOOF_MODE = 'spoof_mode',
    SPOOF_MODE_TIME = 'spoof_mode_time',
    SPOOF_USER = 'spoof_user',
    CAN_SPOOF = 'can_spoof',
    OBJ_ID = 'obj_id',
    OBJ_INFO = 'obj_info',
    DATE_FILTER = 'date_filter',
    LAST_SEEN_PAGE = 'last_seen_page',
    SHOW_PWA_COST = 'show_pwa_cost',
    SHOW_APP_STATUS = 'campaign_report_show_app_status',
    SHORT_OFFER_NAME = 'short_offer_name',
    ACTIVE_REPORT_TAB = 'active_report_tab',
    ACTIVE_FTD_REPORT_TAB = 'active_ftd_report_tab',
    PIN_REPORT_GRAPH = 'pin_report_graph',
    TIME_ZONE = 'time_zone',
    PWA_REFRESH_RUNNING_JOBS = 'pwa_refresh_running_jobs',
    AFFID_SHOW_PLATFORM_COL = 'affid_show_platform_col',
    AFFID_SHOW_GEO_COL = 'affid_show_geo_col',
    AFFID_COMPARE_FILTER = 'affid_compare_filter',
    AFFID_SELECTED_DATE_OPTION = 'affid_selected_date_option',
    PERMISSIONS_OPEN = 'permissions_open',
    PIXEL_BUNDLE_SHOW_BANNED_PIXELS = 'pixel_bundle_show_banned_pixels',
}
